import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (!isOpen) return;
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleEsc);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleEsc);
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-115">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-md" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="legal-modal-title" data-id="element-116">
          <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="glass-panel rounded-2xl w-full max-w-2xl max-h-[85vh] flex flex-col border-brand-blue/20 overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-117">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-white/5 shrink-0" data-id="element-118">
              <h2 id="legal-modal-title" className="text-xl md:text-2xl font-display font-bold text-white" data-id="element-119">
                {title}
              </h2>
              <button onClick={onClose} aria-label="Cerrar" className="w-9 h-9 rounded-lg bg-white/5 hover:bg-white/10 border border-white/10 flex items-center justify-center transition-colors" data-id="element-120">
                <X className="w-4 h-4 text-gray-400" data-id="element-121" />
              </button>
            </div>

            {/* Content */}
            <div className="overflow-y-auto p-6 md:p-8 text-gray-300 text-sm leading-relaxed space-y-4" data-id="element-122">
              {children}
            </div>

            {/* Footer */}
            <div className="p-4 border-t border-white/5 shrink-0 text-center" data-id="element-123">
              <p className="text-xs text-gray-500 font-mono uppercase tracking-wider" data-id="element-124">
                Última actualización: Enero 2026
              </p>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}